import GetPricingMapper from '@/modules/life/rater/mappers/MID/GetPricingMapper'

export default {
  GetPricingMapper
}
